<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
<!--          <a-col :span="24">-->
<!--            <a-form-item label="平台标识，0 iOS，1 Android" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <j-dict-select-tag type="radio" v-decorator="['platformId', validatorRules.platformId]" :trigger-change="true" dictCode="" placeholder="请选择平台标识，0 iOS，1 Android"/>-->
<!--            </a-form-item>-->
<!--          </a-col>-->

          <a-col :span="24">
            <a-form-item label="平台标识" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <div style="padding-left: 50px;">
                <a-radio-group v-model="value" v-decorator="['platformId']" >
                  <a-radio :value="0">
                    iOS
                  </a-radio>
                  <a-radio :value="1">
                    Android
                  </a-radio>
                </a-radio-group>
              </div>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="平台名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['platformName', validatorRules.platformName]" placeholder="请输入平台名称 iOS、Android"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="版本号第一位" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['version1', validatorRules.version1]" placeholder="请输入版本号第一位" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="版本号第二位" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['version2', validatorRules.version2]" placeholder="请输入版本号第二位" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="版本号第三位" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['version3', validatorRules.version3]" placeholder="请输入版本号第三位" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="版本号  ex:1.0.0" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['version', validatorRules.version]" placeholder="请输入版本号  ex:1.0.0"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="强制升级:" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <div style="padding-left: 50px;">
                <a-radio-group v-model="value1" v-decorator="['forceUpgrade']">
                  <a-radio :value="0">
                    不强制
                  </a-radio>
                  <a-radio :value="1">
                    强制
                  </a-radio>
                </a-radio-group>
              </div>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="升级链接" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['url', validatorRules.url]" placeholder="请输入升级链接"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="创建人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['createUser', validatorRules.createUser]" placeholder="请输入创建人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="升级文案" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['content', validatorRules.content]" placeholder="请输入升级文案"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@comp/jeecg/JFormContainer'
  import JDate from '@comp/jeecg/JDate'
  import JDictSelectTag from "@comp/dict/JDictSelectTag"

  export default {
    name: 'SysAppUpgradeForm',
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
validatorRules: {
        platformId: {
        rules: [
            { required: true, message: '请输入平台标识，0 iOS，1 Android!'},
        ]
        },
        platformName: {
        rules: [
            { required: true, message: '请输入平台名称 iOS、Android!'},
        ]
        },
        version1: {
        rules: [
            { required: true, message: '请输入版本号第一位!'},
        ]
        },
        version2: {
        rules: [
            { required: true, message: '请输入版本号第二位!'},
        ]
        },
        version3: {
        rules: [
            { required: true, message: '请输入版本号第三位!'},
        ]
        },
        version: {
        rules: [
            { required: true, message: '请输入版本号  ex:1.0.0!'},
        ]
        },
        forceUpgrade: {
        rules: [
            { required: true, message: '请输入是否强制升级!'},
        ]
        },
        url: {
        rules: [
            { required: true, message: '请输入升级链接!'},
        ]
        },
        createTime: {
        rules: [
            { required: true, message: '请输入创建时间!'},
        ]
        },
        createUser: {
        rules: [
            { required: true, message: '请输入创建人!'},
        ]
        },
        content: {
        rules: [
            { required: true, message: '请输入升级文案!'},
        ]
        },
},
        url: {
          add: "/app/sysAppUpgrade/add",
          edit: "/app/sysAppUpgrade/edit",
          queryById: "/app/sysAppUpgrade/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'platformId','platformName','version1','version2','version3','version','forceUpgrade','url','createTime','createUser','content'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'platformId','platformName','version1','version2','version3','version','forceUpgrade','url','createTime','createUser','content'))
      },
    }
  }
</script>